import React, { useEffect, useState } from 'react';
import { easings, useSpring } from 'react-spring';
import { Label, ShowFiltersCTA } from './VehicleResultsContainer.styles';
import FilterIcon from '../../assets/icons/FilterIcon';
import { COLORS } from '../../styles/variables';
import useComplexAnimations from '../../hooks/Animations/useComplexAnimations';

interface ShowFilterCTATypes {
  isFiltersOpen: boolean;
  setIsFiltersOpen: (arg: boolean) => void;
  scrolled: boolean;
}
const ShowFilterCTA: React.FC<ShowFilterCTATypes> = ({
  isFiltersOpen,
  setIsFiltersOpen,
  scrolled,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const { easeInSine } = easings;

  const [buttonHeight, setButtonHeight] = useSpring(() => ({
    height: 100,
    config: {
      duration: 100,
      easing: easeInSine,
    },
  }));
  const [labelAppearence, setLabelAppearence] = useSpring(() => ({
    opacity: 1,
    display: 'auto',
    config: {
      duration: 100,
      easing: easeInSine,
    },
  }));

  useEffect(() => {
    if (!scrolled) {
      setLabelAppearence({
        opacity: 1,
        display: 'inline-block',
        config: {
          duration: 100,
          easing: easeInSine,
        },
      });
      setButtonHeight({ height: 100 });
    }
    if (scrolled) {
      setLabelAppearence({
        opacity: 0,
        display: 'none',
        config: {
          duration: 100,
          easing: easeInSine,
        },
      });
      setButtonHeight({ height: 50 });
    }
  }, [easeInSine, scrolled, setButtonHeight, setLabelAppearence]);

  const handleMouseEnter = () => {
    setIsHovered(true);
    setLabelAppearence({
      opacity: 1,
      display: 'inline-block',
      config: {
        duration: 100,
        easing: easeInSine,
      },
    });
    setButtonHeight({ height: 100 });
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    if (scrolled) {
      setLabelAppearence({
        opacity: 0,
        display: 'none',
        config: {
          duration: 100,
          easing: easeInSine,
        },
      });
      setButtonHeight({ height: 50 });
    }
  };

  const { showFiltersDesktopAnimation } = useComplexAnimations(isFiltersOpen);

  return (
    <ShowFiltersCTA
      onClick={() => {
        setIsFiltersOpen(true);
      }}
      style={{
        ...showFiltersDesktopAnimation,
        ...buttonHeight,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      $scrolled={scrolled}
      $ishovered={isHovered}
    >
      <FilterIcon color={COLORS.black} />
      <Label style={{ ...labelAppearence }}>Show filters</Label>
    </ShowFiltersCTA>
  );
};

export default ShowFilterCTA;
